export default "__VITE_ASSET__BmQpWBWy__"